var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.602 9.521c-.232 0-5.578.034-10.35 2.31C9.477 9.555 4.131 9.52 3.9 9.52a1.15 1.15 0 0 0-1.15 1.15v11.367a1.15 1.15 0 0 0 .35.827c.225.216.553.35.84.322l.145-.001c.786 0 4.941.113 9.68 2.329.018.01.039.006.057.013.137.056.28.095.43.095.147 0 .291-.039.43-.095.018-.007.038-.004.057-.013 4.738-2.218 8.894-2.329 9.68-2.329l.145.001c.274.029.613-.106.839-.322.223-.217.35-.516.35-.827V10.672a1.15 1.15 0 0 0-1.15-1.15zM5.05 11.878c1.708.128 5.039.552 8.051 1.946v8.904c-3.45-1.351-6.43-1.718-8.05-1.812v-9.038zm18.402 9.038c-1.622.094-4.6.46-8.05 1.812v-8.904c3.011-1.394 6.342-1.818 8.05-1.946v9.038z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.251 9.522a3.45 3.45 0 1 0 0-6.901 3.45 3.45 0 0 0 0 6.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.2eb35da6da1fa4b02b4ce51828b8d082.svg";
export { ForwardRef as ReactComponent };